"use client";

import { cn } from "@/lib/utils";
import { Block, BLOCKS, Inline } from "@contentful/rich-text-types";
import { ReactNode } from "react";
import Button from "../Button/Button.component";
import { BUTTON_SUBTYPE_CLASS } from "../Button/Button.model";
import { RichText } from "../RichText/RichText.component";
import { Typography } from "../Typography/Typography.component";
import { CopyBlockPropsModel } from "./CopyBlock.model";

const CopyBlock = ({ title, content, align, cta }: CopyBlockPropsModel) => {
  const { json } = content;
  const rightAligned = align === "Right";

  const customRenderNode = {
    [BLOCKS.HEADING_3]: (_node: Block | Inline, children: ReactNode) => (
      <Typography.H3Sentence>{children}</Typography.H3Sentence>
    ),
  };

  return (
    <div
      className={cn(
        "bg-core-white px-sm py-lg md:px-lg md:py-xxxl mb-[-1px] flex flex-col justify-between md:flex-row",
        title && "gap-lg",
      )}
    >
      <div
        className={cn(
          "basis-full md:basis-1/2",
          !rightAligned && !title && "order-last",
        )}
      >
        {!rightAligned && title && (
          <Typography.LLABEL1>{title}</Typography.LLABEL1>
        )}
      </div>
      <div
        className={cn(
          "grid basis-full md:basis-1/2",
          rightAligned && title
            ? "gap-y-xxxl md:gap-y-lg"
            : "gap-y-xxxxl md:gap-y-xxxl",
        )}
      >
        {rightAligned && title && (
          <Typography.H3Sentence>{title}</Typography.H3Sentence>
        )}
        <RichText
          additionalClassName={{
            heading: "!normal-case",
            paragraph: "!text-(size:--font-size-body-lg)",
            link: "",
          }}
          customRenderNode={customRenderNode}
          content={json}
        />
        {cta && (
          <Button
            primary={false}
            type={BUTTON_SUBTYPE_CLASS.SECONDARY_BLACK}
            content={{ ...cta }}
          />
        )}
      </div>
    </div>
  );
};

export default CopyBlock;
